// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";
import { TelemetryEventNames, dispatchTelemetryEvent, genericTelemetryClickDispatcher, getPageContentType } from "../Social.telemetry";

export interface ReactionBreakdownTelemetryObjects {
    container: TelemetryObjectBase;
    tabs: { [tabKey: string]: TelemetryObjectBase };
}

export interface ReactionBreakdownListItemTelemetryObjects {
    container: TelemetryObjectBase;
    userName: TelemetryObjectBase;
    profilePicture: TelemetryObjectBase;
}

export const reactionBreakdownTelemetryContracts = {
    /** Profile Followers > Scenario 1a */
    commentReactionBreakdown: {
        name: "CommentReactionsOverlay",
        content: { type: TelemetryContentType.Comment }
    },
    /** Profile Following > Scenario 1a */
    contentReactionBreakdown: {
        name: "ReactionsOverlay",
        content: { type: getPageContentType() }
    },
    /** Click Tab, Profile Comments > Scenario 4b */
    tab: {
        name: "ReactionsButton",
        behavior: TelemetryBehaviorType.Show,
        content: { type: getPageContentType() }
    }
};

export const reactionBreakdownListItemTelemetryContracts = {
    userNameAndProfilePic: {
        name: "Profile",
        behavior: TelemetryBehaviorType.Navigate,
        content: {
            type: TelemetryContentType.Profile
        }
    }
};

export const reactionBreakdownTelemetryActionDispatchers = {
    /** Used for: Scenario 3a and Scenario 4a */
    tabClicked: (element: any, telemetryObject: TelemetryObjectBase): void => {
        const telemetryEventDispatcherInfo = {
            eventName: TelemetryEventNames.genericAction,
            contract: {...(telemetryObject && telemetryObject.contract)}
        };

        dispatchTelemetryEvent(telemetryEventDispatcherInfo, element);
    },
    genericClick: genericTelemetryClickDispatcher
};